import { createPermission } from "@backstage/plugin-permission-common";

export const crmonReadPermission = createPermission({
  name: "crmon.read",
  attributes: { action: "read" },
});

export const crmonWritePermission = createPermission({
  name: "crmon.write",
  attributes: { action: "create" },
});

export const crmonCommissionsPermission = createPermission({
  name: "crmon.commissions",
  attributes: { action: "read" },
});
